// extracted by mini-css-extract-plugin
export default {"page":"Fzf4x5AL","content":"spGb8EI9","msg":"a1XZzvRQ","offSymbol":"wPSLGctN","contact":"B3_jCArB","footerLogo":"yD9TPbVf","footer":"HnDLmqaQ"};